export default{
    path:'sys_app',
    name:'sys_app',
    component:r => require.ensure([], () => r(require('./index.vue')), 'sys_app'),
    redirect: {name:'sys_app_list'},
    children: [
        {
            path:'sys_app_list',
            name:'sys_app_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'sys_app_list'),
        }
    ]
}